"use client";

import React from "react";
import { Trophy } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
const players = [{
  id: 1,
  name: "Felix maltais",
  photo: "https://enormous-cat-1.10web.cloud/wp-content/uploads/2026/03/IMG_1353.jpg?v=8nsyfdtjmji",
  commitment: "m18AAA - cantiniers de Magog",
  team: "Ulysse académie m18",
  position: "D"
}, {
  id: 2,
  name: "Dante ersoni ",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/7F701915-E420-4F1E-9CEE-E55B8209E608.jpg?v=jznyxn9fwcc",
  commitment: "USPORTS - Univ. of Ottawa",
  team: "Powell river kings BCHL",
  position: "D"
}, {
  id: 3,
  name: "Keanan dewberry",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_0236-copy.jpeg?v=fg746die89b",
  commitment: "USPORTS - UNIV. OF TORONTO",
  team: "Rochester Jr. Americans",
  position: "RW"
}, {
  id: 4,
  name: "Xavier fauchon",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_1206.jpg?v=sxn4kb4dy49",
  commitment: "SJHL - Flin Flon",
  team: "Champlain st Lawrence lions QCHL",
  position: "D"
}, {
  id: 5,
  name: "olivier Tetreault",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_4243.jpeg?v=vha52atj1l",
  commitment: "drafted - Chicoutimi lhjmq ",
  team: "collège Bourget csshl u18",
  position: "D"
}, {
  id: 6,
  name: "Mathys morrisette",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_1868-1.jpg?v=ial0tauer8",
  commitment: "drafted - cape-Breton lhjmq",
  team: "st-Eustache Vikings m18 aaa",
  position: "RW"
}];
export default function AdvancementSuccessStories() {
  return <section data-section-id="69697" id="advancement-success-stories" className="dark bg-background text-foreground py-32 relative overflow-hidden">
      {}
      <div className="absolute -top-24 left-1/4 w-[50rem] h-[50rem] bg-primary/5 rounded-full blur-[160px] pointer-events-none" />
      <div className="absolute -bottom-24 right-1/4 w-[40rem] h-[40rem] bg-primary/10 rounded-full blur-[140px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="mb-20 md:mb-32 flex flex-col md:flex-row md:items-end justify-between gap-12 border-b border-border/20 pb-12">
          <div className="max-w-3xl">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-sans font-black tracking-tighter uppercase mb-6 text-foreground leading-[0.9]">
              Advancement <br />
              <span className="text-primary">Success Stories</span>
            </h2>
            <p className="text-muted-foreground text-xl md:text-2xl max-w-2xl font-sans leading-relaxed">
              Proven results. Explore the career trajectories of elite athletes mentored through our 
              comprehensive scouting and development network.
            </p>
          </div>
          <div className="hidden md:block text-right">
            <p className="text-sm font-mono text-primary uppercase tracking-[0.3em] font-bold">
              DB Hockey Advancement
            </p>
            <p className="text-xs text-muted-foreground mt-2 uppercase font-mono tracking-widest">
              Elite Athleticism • Cold Precision
            </p>
          </div>
        </div>

        <div className="relative group/carousel">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-8">
              {players.map((player, i) => <CarouselItem key={player.id} data-index={i} className="pl-4 md:pl-8 sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="relative h-[550px] group/card overflow-hidden bg-card border border-border transition-all duration-500 hover:border-primary/40 hover:shadow-[0_0_50px_rgba(218,11,11,0.15)]">
                    {}
                    <img src={player.photo} alt={`${player.name} - ${player.commitment}`} className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-1000 ease-out group-hover/card:scale-110 saturate-[0.9]" />

                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent opacity-95 transition-opacity duration-500 group-hover/card:opacity-100" />
                    <div className="absolute inset-0 bg-linear-to-tr from-primary/5 via-transparent to-transparent pointer-events-none" />
                    
                    {}
                    <div className="absolute inset-0 p-8 flex flex-col justify-end z-10">
                      <div className="transform transition-transform duration-500 ease-out group-hover/card:-translate-y-2">
                        <Badge variant="default" className="mb-6 bg-primary text-primary-foreground border-none uppercase tracking-[0.2em] font-mono text-[10px] py-1.5 px-4 rounded-none shadow-[0_4px_15px_rgba(218,11,11,0.3)]">
                          <Trophy className="w-3.5 h-3.5 mr-2" /> Committed
                        </Badge>
                        
                        <h3 className="text-4xl font-sans font-black uppercase tracking-tighter text-foreground mb-2 leading-none">
                          {player.name}
                        </h3>
                        
                        <p className="text-primary font-mono text-sm mb-6 uppercase tracking-wider font-bold">
                          {player.commitment}
                        </p>

                        {}
                        <div className="grid grid-cols-2 gap-4 pt-6 border-t border-border/30 opacity-0 transform translate-y-4 transition-all duration-500 delay-100 group-hover/card:opacity-100 group-hover/card:translate-y-0">
                          <div className="flex flex-col">
                            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono mb-1.5">
                              Position
                            </span>
                            <span className="text-sm text-foreground font-bold font-sans uppercase">
  {player.position}
                        </span>
                          </div>
                          <div className="flex flex-col text-right">
                            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono mb-1.5">
                              Prev Team
                            </span>
                           <span className="text-sm text-foreground font-bold font-sans uppercase break-words">
  {player.team}
                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {}
                    <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-primary/0 transition-all duration-500 group-hover/card:border-primary/60 m-6" />
                    <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-primary/0 transition-all duration-500 group-hover/card:border-primary/60 m-6" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            {}
            <div className="absolute top-1/2 -translate-y-1/2 -left-4 md:-left-16 z-20">
              <CarouselPrevious className="relative left-0 right-auto h-14 w-14 rounded-none bg-background/80 backdrop-blur-xl border-border/50 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-2xl" />
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 -right-4 md:-right-16 z-20">
              <CarouselNext className="relative left-auto right-0 h-14 w-14 rounded-none bg-background/80 backdrop-blur-xl border-border/50 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-2xl" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}